/**
 * @mui/private-theming v5.15.20
 *
 * @license MIT
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
export { default as ThemeProvider } from './ThemeProvider';
export * from './ThemeProvider';
export { default as useTheme } from './useTheme';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@mui/private-theming/index.js
// module id = 1043
// module chunks = 0